// polyfill 兼容底版本
import 'intersection-observer';

/**
 * @desc: 曝光埋点
 * @return {*}
 */

const THRESHOLD = 0.5; // 元素在屏幕中出现75%时

export type ExposurePrams = {
  threshold?: number | number[]; // IntersectionObserver 触发节点
  root?: Element | null; // 需要监听的scroll容器，null为body
  rootMargin?: string;
};

class Exposure {
  private observer: IntersectionObserver | null;
  private cbMap = new WeakMap();
  private option: ExposurePrams = {
    root: null,
    threshold: THRESHOLD,
    rootMargin: '30px',
  };
  constructor(params?: ExposurePrams) {
    if (params) {
      this.option = {
        ...this.option,
        ...params,
      };
    }

    this.observer = null;
    this.init();
  }

  private init() {
    this.observer = new IntersectionObserver(this.callback, {
      root: this.option.root,
      rootMargin: this.option.rootMargin,
      threshold: this.option.threshold, // 目标dom出现在视图的比例 0 - 1
    });
  }

  private callback = (entries: IntersectionObserverEntry[]) => {
    entries?.forEach((entry) => {
      // 在屏幕中显示
      if (entry.isIntersecting) {
        try {
          this.cbMap.get(entry.target)?.();
          this.cbMap.delete(entry.target);
        } catch (e) {
          console.log('曝光错误：', [`${e}`]);
        }
      }
    });
  };

  public add(id: string, cb: () => void) {
    const dom = window.document.querySelector(id);
    if (this.observer) {
      if (dom) {
        this.observer.observe(dom);
        this.cbMap.set(dom, cb);
      }
    } else {
      throw Error('监听对象不存在');
    }
  }

  public remove(id: string) {
    const dom = window.document.querySelector(id);
    if (dom) {
      this.cbMap?.delete(dom);
    }
  }
}

export default Exposure;
